import {
  SUBMIT_INSERT_UPDATE_SHIFT_ACTION_REQUESTED,
  SUBMIT_INSERT_UPDATE_SHIFT_ACTION_DISPATCHER,
  SUBMIT_INSERT_UPDATE_SHIFT_ERROR_DISPATCHER,
  SUBMIT_EMPTY_INSERT_UPDATE_SHIFT_STATE_ACTION,
  INSERT_UPDATE_SHIFT_LOADING,
} from "./Action";

const initialState = {
  successData: { message: "", apiData: {} },
  failureData: { message: "", apiData: {} },
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_INSERT_UPDATE_SHIFT_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_INSERT_UPDATE_SHIFT_ACTION_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.Message,
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case SUBMIT_INSERT_UPDATE_SHIFT_ERROR_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.Message,
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case INSERT_UPDATE_SHIFT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SUBMIT_EMPTY_INSERT_UPDATE_SHIFT_STATE_ACTION:
      return {
        ...state,
        successData: {
          message: "",
          apiData: {},
        },
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
